var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('text-loading-placeholder'):[_vm._t(_vm.slotName)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }